import React, { useState } from "react";
import { Formik, Form } from "formik";
import InputField from "../../../../shared/components/InputField";
import { validationSchema } from "./ResetPasswordValidation";
import UserService from "../../../../services/AuthService/auth.service";
import { withRouter, useLocation } from "react-router-dom";
import backArrow from "../../../../assets/icons/back_arrow.svg";

import './changePassword.scss';
import ButtonComponent from "../../../../shared/components/ButtonComponent";
import * as appRoutes from "../../../../routes/routeConstants/appRoutes";
import { useHistory } from "react-router";

interface User {
  password: string,
  confirmPassword: string
}

const initialValue = {
  password: "",
  confirmPassword: ""
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ResetPassword = (props: any) => {
  const history = useHistory()

  const query = useQuery();

  const [buttonLoading, setButtonLoading] = useState<boolean>(false);

  const onSubmit = (user: User) => {
    setButtonLoading(true)

    let data: any = {};

    data['admin'] = {
      "email": query.get('email'),
      "reset_password_token": query.get('reset_password_token'),
      "new_password": user.password
    }

    UserService.resetPassword(data,
      (user: any) => {
        return props.history.push(appRoutes.LOGIN);
      }, (error: Error) => {
        console.log(error.message);
      }, () => {
        setButtonLoading(false)
      }).then();
  }

  return (
    <div className='auth-component'>
      <div className="auth__wrapper">
        <div className='auth__form'>
          <div className="auth__header">
            <img src={backArrow} alt="" className="auth__back" onClick={() => history.goBack()} /> Change Password
            </div>
          <Formik
            initialValues={initialValue}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
          >
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <div className="auth__input">
                <InputField type="password" name="password" placeholder="New Password" />
              </div>
              <div className="auth__input">
                <InputField type="password" name="confirmPassword" placeholder="Confirm Password" />
              </div>
              <div className='auth__action reset-password__action'>
                <ButtonComponent buttonContent='Update'
                  type='primary'
                  htmlType='submit'
                  loading={buttonLoading}
                />
              </div>
            </Form>
          </Formik>
        </div>
      </div>
    </div>
  )
}

export default withRouter(ResetPassword);
